import {
  AbstractControl,
  FormArray,
  FormControl,
  FormGroup,
} from '@angular/forms';

export class FormUtil {
  static updateFormValidity(
    form?: FormGroup | FormArray | FormControl | AbstractControl | null
  ) {
    if (!form) return;
    form.markAllAsTouched();
    form.markAsDirty();
    form.updateValueAndValidity({ onlySelf: true });
    // if form is not an instance of FormControl or AbstractControl
    if (form instanceof FormGroup) {
      Object.values(form.controls).forEach((c) =>
        FormUtil.updateFormValidity(c)
      );
    }
    if (form instanceof FormArray) {
      form.controls.forEach((c) => FormUtil.updateFormValidity(c));
    }
  }
}
